module.exports = __webpack_public_path__ + "img/KSC06844.ed3d586f.jpg";